import { Outlet } from 'react-router-dom';
import Sidebar from '@components/widgets/Sidebar';
import LayoutFooter from '@components/layouts/LayoutFooter';

const PrivateLayout = () => {
  return (
    <div className="layout_wrapper w-full h-full flex-col md:flex-row">
      <Sidebar />
      <Outlet />
      <LayoutFooter />
    </div>
  );
};

export default PrivateLayout;
